import React from 'react'
import { SVGProps } from 'react'

const ChevronDownIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={14}
    height={15}
    viewBox="0 0 14 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M0.619616 4.6223C0.277574 4.9637 0.277503 5.51787 0.619454 5.85936L5.55333 10.7865C5.93671 11.1681 6.4556 11.3823 6.9965 11.3823C7.5374 11.3823 8.05629 11.1681 8.43967 10.7865L13.3805 5.85294C13.7224 5.51149 13.7223 4.9573 13.3802 4.616C13.039 4.27561 12.4866 4.27574 12.1456 4.61631L7.203 9.55217C7.1483 9.60685 7.07413 9.63756 6.99679 9.63756C6.91945 9.63756 6.84528 9.60685 6.79058 9.55217L1.85469 4.6225C1.51353 4.28177 0.960883 4.28168 0.619616 4.6223Z" />
  </svg>
)
export default ChevronDownIcon
